export const meetingsEn = {
  title: "Meetings",
  add_button: "Add Granola notes",
  badge: "%{smart_count} note to link |||| %{smart_count} notes to link",
  tabs: { unmatched: "To match", matched: "Matched", internal: "Internal" },
  empty: {
    unmatched: "No notes to match.",
    matched: "No matched notes in the last 30 days.",
    internal: "No internal meetings.",
  },
  paste: {
    title: "Add Granola notes",
    help: "In Granola, open the note, click “Copy”, then paste the text here.",
    text_label: "Granola notes",
    text_placeholder: "Paste the notes copied from Granola…",
    chars: "%{count} / %{max} characters",
    title_label: "Meeting title",
    started_at_label: "Meeting date and time",
    share_url_label: "Granola share link (optional)",
    target_label: "Lead",
    deal_label: "Deal (optional)",
    no_results: "No results",
    no_deal: "No deal",
    preview_items:
      "%{smart_count} action found |||| %{smart_count} actions found",
    transcript_removed: "The transcript was removed: only the notes are kept.",
    save: "Save",
    cancel: "Cancel",
    saved: "Granola notes added.",
    duplicate: "These notes were already added.",
  },
  card: {
    granola: "Granola notes",
    granola_call: "🎙️ Granola", // GAVION granola-calls
    spans_calls: "This note may cover several calls.",
    show_more: "Show all",
    show_less: "Collapse",
    open_granola: "Open in Granola",
    demo_held: "Demo held",
    attendees: "Attendees",
    section_title: "Meeting notes",
    none: "No meeting notes.",
  },
  tasks: {
    title: "Suggested tasks",
    create: "Create selected tasks",
    created: "%{smart_count} task created |||| %{smart_count} tasks created",
    none_selected: "Select at least one task.",
    due: "Due: %{date}",
  },
  inbox: {
    associate: "Match to…",
    ignore: "Ignore",
    associate_title: "Match the note",
    save: "Match",
    associated: "Note matched.",
    ignored: "Note ignored.",
    restore: "Restore",
    restored: "Note restored.",
    suggest: "Link to %{name}?",
    suggested: "Note linked to %{name}.",
    reasons: {
      booked_demo: "demo booked at %{time}",
      phone: "lead's number",
      attendee: "attendee's email",
      title: "name in the title",
    },
  },
  errors: {
    empty_note: "Paste the notes before saving.",
    note_too_large: "Text too long (50,000 characters maximum).",
    started_at_required: "Enter the meeting date.",
    future_date: "The meeting date cannot be in the future.",
    company_not_found: "Lead not found.",
    deal_not_found: "Deal not found.",
    deal_company_mismatch: "This deal does not belong to this lead.",
    contact_company_mismatch: "This contact does not belong to this lead.",
    invalid_share_url: "Invalid Granola link (https://notes.granola.ai/…).",
    invalid_attendees: "Invalid attendee list.",
    not_found: "Note not found.",
    note_not_matched: "Match the note to a lead first.",
    too_many_items: "20 tasks at most at a time.",
    forbidden: "Not allowed.",
    unknown: "Something went wrong. Try again.",
  },
};
